export default __webpack_public_path__ + "static/media/Ivan_Lee_resume.eb481051.pdf";